export const AdminEnabledFields = [
  'hubspotObjectId',
  'hubspotCompanyId',
  'orgType',
  'orgType_subCategory',
  'ttLockConnectionString',
  'ttLockHardwareIdentifier',
];